function utils() {
    let calcMaxHeight = function (items) {
        let maxHeight = 0;
        items.forEach(item => {
            let h = item.clientHeight;
            maxHeight = h > maxHeight ? h : maxHeight;
        });
        return maxHeight;
    }
    function removeClasses(nodeList, cssClasses) {
        for (let i = 0; i < nodeList.length; i++) {
            nodeList[i].classList.remove(...cssClasses);
        }
    }
    function addClasses(nodeList, cssClasses) {
        for (let i = 0; i < nodeList.length; i++) {
            nodeList[i].classList.add(...cssClasses);
        }
    }
    function getIndex(items, attributeName){
         let activeIndex='';
          items.forEach(item => {
           if(item.classList.contains('active')){
             activeIndex=item.getAttribute(attributeName);
           }
        });
      return activeIndex
    }
    let requestInterval = function (fn, delay) {
        let requestAnimFrame = (function () {
            return window.requestAnimationFrame || function (callback, element) {
                window.setTimeout(callback, 1000 / 60);
            };
        })();

        let start = new Date().getTime(),
            handle = {};

        function loop() {
            let current = new Date().getTime(),
                delta = current - start;

            if (delta >= delay) {
                fn.call();
                start = new Date().getTime();
            }

            handle.value = requestAnimFrame(loop);
        }

        handle.value = requestAnimFrame(loop);
        return handle;
    };
    let clearRequestInterval = function (handle) {
        window.cancelAnimationFrame ? window.cancelAnimationFrame(handle.value) :
            clearInterval(handle);
    };
    return {
        calcMaxHeight,
        removeClasses,
        getIndex,
        addClasses,
        requestInterval,
        clearRequestInterval
    }
}

function heroSlider(section=document) {
    let heroSliders=section.querySelectorAll("[data-split-slider]");
    Array.from(heroSliders).forEach(function(heroSlider){
    let slider = { 
        hero: heroSlider.querySelector('[data-hero-slider]'),
        main: heroSlider.querySelector('[data-slides-main]'),
        aux: heroSlider.querySelector('[data-slides-aux]'),
        current: heroSlider.querySelector('[data-main-slider-nav]'),
        handle: null,
        idle: true,
        activeIndex: -1,
        interval: 3500
    };
    let setHeight = function (holder, items) {
        let h = utils().calcMaxHeight(items);
        holder.style.height = `${h}px`;
    }

    let leadingZero = function () {
        return arguments[1] < 10 ? '0' + arguments[1] : arguments[1];
    }

    let setCurrent = function () {
        slider.current.setAttribute("data-current", leadingZero `${slider.activeIndex + 1}`) ;
    }
    let sliderSlide = function(activeIndexValue,getindex){
           utils().removeClasses(slider.items, ['prev', 'active']);
        	 let prevItems = [...slider.items]
        		.filter(item => {
        			let prevIndex;
                   prevIndex = activeIndexValue ;
                   return item.dataset.index == prevIndex;
               });
            let activeItems = [...slider.items]
             .filter(item => {
                 return item.dataset.index == getindex;
             });
            if(activeIndexValue > getindex){
          	utils().addClasses(activeItems, ['animInLeft','active']);
          	utils().addClasses(prevItems, ['prev','temp-active']);
              setTimeout(function(){
          	utils().removeClasses(activeItems, ['animInLeft']);
          	utils().removeClasses(prevItems, ['temp-active']);
              },1000)
            }else{
          	utils().addClasses(activeItems, ['animInRight','active']); 
          	utils().addClasses(prevItems, ['prev','temp-active']);
              setTimeout(function(){
          	utils().removeClasses(activeItems, ['animInRight']);
          	utils().removeClasses(prevItems, ['temp-active']);
              },1000)          
            }
           heroSlider.querySelector("[data-background]").style.backgroundColor = activeItems[0].getAttribute('data-color');
        	setCurrent();
        if(slider.main){
          let activeImageItem = slider.main.querySelector('.active');
          activeImageItem.addEventListener('transitionend', waitForIdle, {
              once: true
          });
        }
            
      }
    let changeSlide = function (direction) {
        slider.idle = false;
        slider.hero.classList.remove('prev', 'next');
        
        if (direction == 'next') {
            slider.activeIndex = (slider.activeIndex + 1) % slider.total;
            slider.hero.classList.add('next');
        } else {
           
            slider.activeIndex = (slider.activeIndex - 1 + slider.total) % slider.total;
            console.log(slider.activeIndex)
            slider.hero.classList.add('prev');
        }
        //reset classes
        utils().removeClasses(slider.items, ['prev', 'active']);

        //set prev  
        let prevItems = [...slider.items]
            .filter(item => {
                let prevIndex;
                if (slider.hero.classList.contains('prev')) {
                    prevIndex = slider.activeIndex == slider.total - 1 ? 0 : slider.activeIndex + 1;
                } else {
                    prevIndex = slider.activeIndex == 0 ? slider.total - 1 : slider.activeIndex - 1;
                }

                return item.dataset.index == prevIndex;
            });
        //set active
        let activeItems = [...slider.items]
            .filter(item => {
                return item.dataset.index == slider.activeIndex;
            });
       utils().addClasses(activeItems, ['animInRight','active']);
       utils().addClasses(prevItems, ['prev']);
       setTimeout(function(){
          	utils().removeClasses(activeItems, ['animInRight']);
        },slider.interval)      
        heroSlider.querySelector("[data-background]").style.backgroundColor = activeItems[0].getAttribute('data-color');
        setCurrent();
        if(slider.main){
            let activeImageItem = slider.main.querySelector('.active');
            activeImageItem.addEventListener('transitionend', waitForIdle, {
                once: true
            });
        } 
    }
    let stopAutoplay = function () {
        slider.autoplay = false;
        utils().clearRequestInterval(slider.handle);
    }
    let waitForIdle = function () {
        !slider.autoplay && autoplay(false); //restart
        slider.idle = true;
    }
    let navigation =function(){
      let navigationBars = heroSlider.querySelectorAll("[data-slider-nav]");
      Array.from(navigationBars).forEach(function(navigationBar){
      navigationBar.addEventListener('click', e => {
        e.preventDefault();
        if(navigationBar.classList.contains('active')) return false;
        let activeIndexValue=parseInt(utils().getIndex(navigationBars,'data-nav-index'));
        utils().removeClasses(navigationBars, ['active']);
          navigationBar.classList.add('active')
          let getindex=parseInt(navigationBar.getAttribute("data-nav-index"));
          getindex=parseInt(getindex);
          slider.hero.classList.remove('prev', 'next');
          if(activeIndexValue > getindex){
               slider.hero.classList.add('prev');
          }else{
            slider.hero.classList.add('next');
          }
        sliderSlide(activeIndexValue,getindex);
        });       
       }) 
    }
    let nextButton =function(){
        let next = heroSlider.querySelector("[data-next_slide_btn]");
        if(next){
            next.addEventListener('click', e => {
                if (slider.idle) {
                    stopAutoplay();
                    changeSlide('next');
                }
            });  
        }
    }
    let previousButton =function(){
        let prev = heroSlider.querySelector("[data-previous_slide_btn]");
        if(prev){
            prev.addEventListener('click', e => {
                if (slider.idle) {
                    stopAutoplay();
                    changeSlide('prev');
                }
            });
        }  
    }
    let autoplay = function (initial) {
        slider.autoplay = true;
        slider.items = slider.hero.querySelectorAll('[data-index]');
        slider.total = slider.items.length / 2;
        let loop = () => changeSlide('next');
        initial && requestAnimationFrame(loop);
        slider.handle = utils().requestInterval(slider.interval);
    }
    let loaded = function () {
        slider.hero.classList.add('loaded');
    }
    let touchControl = function () {
        let touchStart = function (e) {
            slider.ts = parseInt(e.changedTouches[0].clientX);
            window.scrollTop = 0;
        }
        let touchMove = function (e) {
            let currentSlide = e.changedTouches[0];
            slider.tm = parseInt(currentSlide.clientX);
            let delta = slider.tm - slider.ts;
            currentSlideIndex = parseInt(currentSlide.target.dataset.index);
            window.scrollTop = 0;
            if(delta < 0){
                if(heroSlider.querySelector('[data-nav-index="'+(currentSlideIndex+1)+'"]')){
                    heroSlider.querySelector('[data-nav-index="'+(currentSlideIndex+1)+'"]').click();
                }
            }
            else{
                if(heroSlider.querySelector('[data-nav-index="'+(currentSlideIndex-1)+'"]')){
                    heroSlider.querySelector('[data-nav-index="'+(currentSlideIndex-1)+'"]').click();
                }
            }
        }

        slider.hero.addEventListener('touchstart', touchStart,
        { passive: true });
        slider.hero.addEventListener('touchmove', touchMove,
        { passive: true });
    }
    let start = function () {
        autoplay(true);
        stopAutoplay();
        nextButton();
        previousButton();
        navigation();
        if(window.innerWidth <= 1024) {
            touchControl();
        }
        if(slider.aux){
            slider.aux.addEventListener('transitionend', loaded, {
                once: true
            });
        }
        
    }
    let loadingAnimation = function () {
        slider.hero.classList.add('ready');
        start();
        slider.current.addEventListener('transitionend', start, {
            once: true
        });
    }
    let init = function () {
        if(slider.hero){
            loadingAnimation();
        }  
    }
    init();
    
})
}
document.addEventListener("DOMContentLoaded", heroSlider(), false);

